import { TransitionGroup } from 'react-transition-group';
import { Box, Collapse } from "@mui/material"

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import TextField from "@mui/material/TextField";
import dayjs from 'dayjs';

export const Form = (props) => {
    const { loc, setCutoffForm, cutoffForm } = props
    

    const handleChangeTime = (value) => {
        if (value){  
            const hour = value.hour();
            const minute = value.minute();
            setCutoffForm((prev)=>({...prev,  cutoff_time: dayjs(String(hour+":"+minute), "HH:mm")}))
        }
    };

    return (
        <Box height="auto" className="overflowY">
            <TransitionGroup style={{display:'flex', flexDirection:'column', gap:'16px'}}>
                    <Collapse >
                        <Box minHeight={loc === 'create' ? "120px":"140px"} bgcolor="#ffffff" borderRadius="10px" display="flex" alignItems="center" gap={3} px={3} pt="20px">
                            <Box width="100%" display="flex" flexDirection="column">
                                <Box width="100%" display="flex" gap={3}>
                                    <Box width="100%" display="flex" flexDirection="column" >
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <TimePicker
                                                label="Business Day Cutoff Time"
                                                value={cutoffForm.cutoff_time}
                                                onChange={(value) => handleChangeTime(value)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>  
                    </Collapse>
            </TransitionGroup>    
        </Box>
    )
}